const CLASS_CURRENT: string = 'current';

function main(): void
{
	const container = document.querySelector( 'main.vacancies' ) as HTMLElement;
	
	if ( !container )
	{
		return;
	}
	
	const form = container.querySelector( 'form' ) as HTMLFormElement;

	if ( !form )
	{
		return;
	}
	
	const aside = form.querySelector( 'aside.success' ) as HTMLElement;
	
	form.addEventListener(
		'submit',
		( event: Event ) =>
		{
			event.preventDefault();
			ajaxLoad( form, aside );
		}
	);
}

function ajaxLoad( form: HTMLFormElement, aside: HTMLElement ): void
{
	const request: XMLHttpRequest = new XMLHttpRequest();
	const data: FormData = new FormData( form );

	request.open( form.method, form.action, true );
	request.addEventListener( 'load', show );
	request.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
	request.send( data );

	function show(): void
	{
		if ( ( request.readyState === XMLHttpRequest.DONE )
			&& ( request.status === 200 ) )
		{
			aside.classList.add( CLASS_CURRENT );
			form.reset();
		}
		else
		{
			alert( 'Сообщение не отправлено, попробуйте снова.');
		}
	}
}

export {
	main as default,
}
